import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);
const axios1 = new HttpRequest(process.env.VUE_APP_API_BASE_URL1);
import moment from 'moment';

export default {
    h5login(data) {
        return axios.request({
            url: "user/login-wx-wap",
            method: "post",
            data
        });
    },
    getUserInfo(data) {
        return axios.request({
            url: "user/userinfo",
            method: "post",
            data
        })
    },
    editUserInfo(data) {
        return axios1.request({
            url: "user/edit-info",
            method: "put",
            data
        });
    },
    myOrder(data) {
        return axios.request({
            url: "user/myorder",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data.list;
                list.forEach((item) => {
                    item.skuInfo = item.orderDetail[0]
                })
            }
            return res;
        })
    },
    expressinfo(data) {
        return axios.request({
            url: "user/orderexpress",
            method: "post",
            data
        });
    },
    mycalories(data) {
        return axios.request({
            url: "user/mycalories",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data.list
                list.forEach((item) => {
                    var da = new Date(item.create_time * 1000),
                        year = da.getFullYear() + '年',
                        month = da.getMonth() + 1 + '月',
                        date = da.getDate() + '日',
                        hour = da.getHours(),
                        minute = da.getMinutes();
                    if (hour < 10) {
                        hour = "0" + hour;
                    }
                    if (minute < 10) {
                        minute = "0" + minute;
                    }
                    item.imgurl = `${item.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_600,h_600,ar_auto`
                    item.show_time = year+ month + date + " " + hour + ":" + minute;
                })
            }
            return res;
        });
    },
    getPoints(data) {
        return axios.request({
            url: "user/user-point-record",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data.list
                list.forEach((item) => {
                    var da = new Date(item.create_time * 1000),
                        year = da.getFullYear() + '年',
                        month = da.getMonth() + 1 + '月',
                        date = da.getDate() + '日',
                        hour = da.getHours(),
                        minute = da.getMinutes();
                    if (hour < 10) {
                        hour = "0" + hour;
                    }
                    if (minute < 10) {
                        minute = "0" + minute;
                    }

                    item.recorddate = month + date + " " + hour + ":" + minute;
                    item.curMounth = year + month;
                    item.month = month;
                })
            }
            return res;
        })
    },
    getRecords: (data) => {
        return axios.request(
            {
                url: "sports/sports-item-user",
                method: 'POST',
                data
            }
        ).then(res=>{
            if (+res.status === 200) {
                res.data.list.forEach((item, index) => {
                    item.create_time = moment(item.create_time * 1000).format('MM月DD日 HH:mm');
                });
    
            }
            return res;
        })
    },
    myvotes(data) {
        return axios.request({
            url: "user/myvotes",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data.list
                list.forEach((item) => {
                    var da = new Date(item.create_time * 1000),
                        year = da.getFullYear() + '年',
                        month = da.getMonth() + 1 + '月',
                        date = da.getDate() + '日',
                        hour = da.getHours(),
                        minute = da.getMinutes();
                    if (hour < 10) {
                        hour = "0" + hour;
                    }
                    if (minute < 10) {
                        minute = "0" + minute;
                    }
                    item.imgurl = `${item.mediaurl}?x-oss-process=video/snapshot,t_5000,f_jpg,w_574,h_355,ar_auto`
                    item.show_time = year+ month + date + " " + hour + ":" + minute;
                })
            }
            return res;
        });
    },
    getRegion(data) {
        return axios.request({
            url: "region/list",
            method: "post",
            data
        }).then((res) => {
            if (res.status * 1 === 200) {
                let list = res.data
                let columns = []
                list.forEach((item) => {
                    columns.push(item.name)
                })
                res.columns = columns
            }
            return res;
        });
    },
    editRegion(data) {
        return axios.request({
            url: "region/user-region",
            method: "post",
            data
        });
    }
}
